import { Link } from "react-router-dom";
import { Instagram, Mail, Heart, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F4EFE6] border-t border-[#EAE3D9] mt-16"
    >
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl">Teddys tiny friends</div>
          <p className="mt-4 text-[#5C4D43] max-w-md leading-relaxed">
            A brand-new little shop of hand-crocheted animal friends, stitched one loop at a time
            from our family home. Made with love, named after our son Teddy.
          </p>
          <div className="mt-6 flex items-center gap-4">
            <a
              data-testid="footer-instagram"
              href="https://www.instagram.com/teddystinyfriendsuk/"
              target="_blank"
              rel="noreferrer"
              className="p-2 rounded-full bg-white border border-[#EAE3D9] hover:border-[#D97757] transition"
            >
              <Instagram size={18} />
            </a>
            <a
              data-testid="footer-email"
              href="mailto:info@teddystinyfriends.co.uk"
              className="p-2 rounded-full bg-white border border-[#EAE3D9] hover:border-[#D97757] transition"
            >
              <Mail size={18} />
            </a>
            <a
              data-testid="footer-trustpilot"
              href="https://www.trustpilot.com/review/teddystinyfriends.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full bg-white border border-[#EAE3D9] hover:border-[#00B67A] transition"
              title="Read our Trustpilot reviews"
            >
              <Star size={18} className="text-[#00B67A]" />
            </a>
          </div>
        </div>

        <div>
          <Link to="/shop" data-testid="footer-shop-heading" className="font-serif text-xl mb-4 inline-block hover:text-[#D97757] transition">Shop</Link>
          <ul className="space-y-2 text-[#5C4D43]">
            <li><Link to="/shop" data-testid="footer-shop-all" className="hover:text-[#D97757]">All animals</Link></li>
            <li><Link to="/personalise" data-testid="footer-shop-custom" className="hover:text-[#D97757]">Personalisation</Link></li>
          </ul>
        </div>

        <div>
          <Link to="/about" data-testid="footer-studio-heading" className="font-serif text-xl mb-4 inline-block hover:text-[#D97757] transition">Studio</Link>
          <ul className="space-y-2 text-[#5C4D43]">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-[#D97757]">Our story</Link></li>
            <li><Link to="/safety" data-testid="footer-safety" className="hover:text-[#D97757]">Safety &amp; compliance</Link></li>
            <li><Link to="/refunds" data-testid="footer-refunds" className="hover:text-[#D97757]">Refunds &amp; returns</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#D97757]">Contact</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin" className="hover:text-[#D97757]">Admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#EAE3D9]">
        <div className="container-x py-6 flex items-center justify-between text-sm text-[#5C4D43]">
          <div>© {new Date().getFullYear()} Teddys Tiny Friends · UK delivery via Royal Mail</div>
          <div className="flex items-center gap-1.5">
            Made with <Heart size={14} className="text-[#D97757] fill-[#D97757]" /> & yarn
          </div>
        </div>
      </div>
    </footer>
  );
}
